import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import styled from 'styled-components';
import ProductGridRow from './ProductGridRow.js';

import { getActiveListingPage } from '../../reduck/selectors';

const GridOnLoadBeacon = styled.img`
  position: absolute;
  top: 0;
  left: 0;
`;

function ProductGrid({ productsList, numberOfProductsPerRow, sponsoredProducts }) {
  const productGrid = [];


  let productListWithSponsoredProducts;

  if (sponsoredProducts?.items) {
    // we must not show a regular product if it is also contained in sponsored products,
    // because the product would be shown twice on the listing page
    productListWithSponsoredProducts =
      productsList.filter((currentProduct) => (
        !sponsoredProducts.items.map((sponsoredProduct) => sponsoredProduct.id).includes(currentProduct.id)
      ));

    const startIndexWhereToAddSponsoredProducts =
        numberOfProductsPerRow === 3 ? 3 : 4;

    // adding sponsored products to the product list
    productListWithSponsoredProducts.splice(startIndexWhereToAddSponsoredProducts, 0, ...sponsoredProducts.items);

  } else {
    // no sponsored products, so we show only show productList
    productListWithSponsoredProducts = productsList;
  }

  for (let index = 0; index < productListWithSponsoredProducts.length; index += numberOfProductsPerRow) {
    const rowProductsList = productListWithSponsoredProducts.slice(index, index + numberOfProductsPerRow);
    const key = `ids: ${rowProductsList.map((product) => product.id)} ` +
      `length: ${rowProductsList.length}`;

    productGrid.push(
      <ProductGridRow
        key={key}
        rowProductsList={rowProductsList}
        firstGridRow={index === 0}
      />
    );
  }

  return (
    <>
      {sponsoredProducts?.onLoadBeacon
        ? (
          <GridOnLoadBeacon src={sponsoredProducts.onLoadBeacon} alt={'beacon'} />
        ) : null }
      {productGrid}
    </>
  );
}

ProductGrid.propTypes = {
  productsList: PropTypes.arrayOf(PropTypes.object).isRequired,
  sponsoredProducts: PropTypes.shape({
    items: PropTypes.arrayOf(PropTypes.object).isRequired,
    onLoadBeacon: PropTypes.string.isRequired
  }),
  numberOfProductsPerRow: PropTypes.number.isRequired
};

ProductGrid.defaultProps = {
  sponsoredProducts: null
};

function mapStateToProps(state) {
  return {
    productsList: getActiveListingPage(state).productList,
    sponsoredProducts: getActiveListingPage(state).sponsoredProducts ? getActiveListingPage(state).sponsoredProducts : null,
    numberOfProductsPerRow: state.listingPage.browser
      ? getNumberOfProductsPerRowInGrid(state.listingPage.browser.viewportWidth) : 4
  };
}

export default connect(mapStateToProps)(ProductGrid);


function getNumberOfProductsPerRowInGrid(windowWidth) {
  if (windowWidth <= 599) {
    return 2;
  } if (windowWidth > 599 && windowWidth < 769) {
    return 3;
  }
  return 4;
}
